__turbopack_context__.v({
  "arrowWrapper": "compare-module-scss-module__fB2nhW__arrowWrapper",
  "buttonPrimary": "compare-module-scss-module__fB2nhW__buttonPrimary",
  "button___simple": "compare-module-scss-module__fB2nhW__button___simple",
  "close__button": "compare-module-scss-module__fB2nhW__close__button",
  "container": "compare-module-scss-module__fB2nhW__container",
  "container__actions": "compare-module-scss-module__fB2nhW__container__actions",
  "container__logo": "compare-module-scss-module__fB2nhW__container__logo",
  "container__menu": "compare-module-scss-module__fB2nhW__container__menu",
  "container__more": "compare-module-scss-module__fB2nhW__container__more",
  "container__title": "compare-module-scss-module__fB2nhW__container__title",
  "container__wrapper": "compare-module-scss-module__fB2nhW__container__wrapper",
  "drawerHeaderBack": "compare-module-scss-module__fB2nhW__drawerHeaderBack",
  "drawer__footer": "compare-module-scss-module__fB2nhW__drawer__footer",
  "dropdown__container": "compare-module-scss-module__fB2nhW__dropdown__container",
  "logo__title": "compare-module-scss-module__fB2nhW__logo__title",
  "menu__item": "compare-module-scss-module__fB2nhW__menu__item",
});
